export class ClientToken {
    constructor(
        public id: string,
        public type: string,
        public data: string
    ) {}
}
